"use client";
import { motion } from "framer-motion";

export function ReviewsCta() {
  return (
    <section
      id="reviews-cta"
      className="py-24 bg-card text-card-foreground dark:bg-stone-900 dark:text-foreground transition-colors"
      data-header-scheme="dark"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <h2 className="font-serif text-3xl md:text-4xl font-light mb-6 tracking-tight">
            Ready to Join Our Satisfied Customers?
          </h2>
          <p className="text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
            Experience the quality and craftsmanship that has earned us these
            outstanding reviews.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <motion.a
              href="/concretta"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="inline-flex items-center justify-center px-8 py-3 bg-foreground text-background font-semibold rounded-lg hover:bg-foreground/90 transition-colors"
            >
              Shop Concretta
            </motion.a>
            <motion.a
              href="/applicators"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="inline-flex items-center justify-center px-8 py-3 border border-border text-foreground font-semibold rounded-lg hover:bg-foreground hover:text-background transition-colors"
            >
              Find an Applicator
            </motion.a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
